import React, { useState, useEffect} from 'react';

// import CollectionPreferences from "@amzn/awsui-components-console/collection-preferences";
import {
    Box,
    Container,
    Header,
    Pagination,
} from "@amzn/awsui-components-react";
import { Link, useLocation, useParams } from "react-router-dom";
import { getCleanedItemContent } from '../CloseHelperMethods';

function AppsCarouselComponent(props) {
  const [
    selectedItems,
    setSelectedItems
  ] = React.useState([{ name: "Item 2" }]);
  const [carouselIndex, setCarouselIndex] = React.useState(1);
  const [jsonContent, setJsonContent] = React.useState(props?.jsonContent)

  useEffect (() => {
    setJsonContent(props?.jsonContent)
  }, [props?.jsonContent])

  return (
    <Container
        header={
            <Header
                variant="h2"
            >
               <Link to={jsonContent?.items[carouselIndex - 1]?.link}><span style={{ color: "#006ce0", fontWeight: "700", fontSize:"20px", }}>{jsonContent?.items[carouselIndex - 1]?.title}</span></Link>
            </Header>
        }>
        <p>{getCleanedItemContent(jsonContent?.items[carouselIndex - 1]?.description)}</p>
        <Box float='right'>
        <Pagination
        currentPageIndex={carouselIndex}
        onChange={({ detail }) => {

            setCarouselIndex(detail?.currentPageIndex)
        }
        }
        pagesCount={jsonContent?.items?.length}
        />
        </Box>
    </Container>
  );
}

export default AppsCarouselComponent;